import React from 'react';
import {instanceTitle} from "../sections";
import {capitaliseFirst} from "../applicant/__strings";

export default function uploads(props) {
    return {
        name: `uploads`,
        title: 'Upload your documentation',
        link: `upload`,
        props: props,
        uploads: makeUploads(props.mortgage),
        applicant: false
    }
}
function makeUploads(mortgage) {
    let uploads = makeApplyApplicantUploads(mortgage, 1)
    if (mortgage.twoApplicants) {
        uploads = [...uploads, ...makeApplyApplicantUploads(mortgage, 2)]
    }
    uploads = [...uploads, ...makeApplyMortgageUploads()]
    return uploads.map(item=>{
        const i = {...item}
        i.stage="APPLY"
        i.type = 'UPLOAD'
        i.root = i.name
        if (i.applicant){
            i.name = i.name + '-' + i.applicant
        }
        i.link= i?.index ? i.root + '/' + i.index : i.root
        i.title = capitaliseFirst(i.title)
        i.props = {mortgage: mortgage}
        return i
    })
}

function makeApplyApplicantUploads(mortgage, applicant) {
    const uploadList = [
        {
            name: 'proof-of-address',
            title: 'proof of address',

        },
        {
            name: 'identification',
            title: 'identification',

        },
        {
            name: 'bank-statements',
            title: 'bank statements',

        }
    ]
    const appIndex = 'applicant' + applicant
    switch (mortgage[appIndex].employment.employmentType) {
        case 'EMPLOYED' :
            uploadList.push({
                name: 'salary-cert',
                title: 'salary certificate',

            })
            uploadList.push({
                name: 'employment-summary',
                title: 'employment summary',

            })
            uploadList.push({
                name: 'payslips',
                title: 'payslips',

            })
            break
        case 'SELFEMPLOYED' :
            uploadList.push({
                name: 'accounts',
                title: 'financial accounts',

            })
            uploadList.push({
                name: 'form11',
                title: 'form 11',

            })
            uploadList.push({
                name: 'tax-clearance',
                title: 'tax clearance certificate',

            })
            uploadList.push({
                name: 'business-statements',
                title: 'business bank statements',

            })
            break
        default:
    }
    switch (mortgage[appIndex].personal.maritalStatus) {
        case 'MARRIED':
        case 'REMARRIED':
            uploadList.push({
                name: 'marriage-cert',
                title: 'marriage certificate',

            })
            break
        case 'DIVORCED':
            uploadList.push({
                name: 'divorce-decree',
                title: 'decree of divorce',

            })
            break
        default:
    }
    mortgage[appIndex].assets.forEach(asset => {
        let title = asset.institution
        switch (asset['assetType']) {
            case 'SAVING':
                title += ' savings'
                break
            case 'INVESTMENT':
                title += ' investment'
                break
            default:
        }
        uploadList.push({
            name: 'assets',
            title: title + ' statements',
            index: asset.id,

        })
    })
    mortgage[appIndex].debts.forEach(debt => {
        let title = debt.lender
        switch (debt['debtType']) {
            case 'CREDITCARD':
                title += '  credit card'
                break
            case 'STORECARD':
                title += ' store card'
                break
            case 'LOAN':
                title += ' loan'
                break
            case 'OVERDRAFT':
                title += ' overdraft'
                break
            default:
        }
        uploadList.push({
            name: 'debts',
            title: title + ' statements',
            index: debt.id,

        })
    })
    return uploadList.map(item=>{
        item.applicant = applicant
        return item
    })

}
function makeApplyMortgageUploads() {
    return [
        {
            name: 'gift-evidence',
            title: 'gift evidence',
            applicant: false,

        }, {
            name: 'other-documents',
            title: 'any other documents',
            applicant: false,
        }
    ]
}